<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="pageTitle"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>


    @if (detailsType === 'sms') {
      <tidy-row [align]="'center'">
        <tidy-text
          [body]="'TIDY successfully sent this sms to'" /><span>&nbsp;</span>
          <tidy-text
            [body]="notification?.homekeeper?.first_name + ':'" />
        </tidy-row>
        <tidy-card>
          <tidy-row>
            <tidy-text
              [body]="notification?.notifications?.sms?.content?.message" />
          </tidy-row>
        </tidy-card>
      }

      @if (detailsType === 'email') {
        <tidy-row [align]="'center'">
          <tidy-text
            [body]="'TIDY successfully sent this email to'" /><span>&nbsp;</span>
            <tidy-text
              [body]="notification?.homekeeper?.first_name + ':'" />
          </tidy-row>
          <tidy-card>
            <tidy-row>
              <tidy-text
                [header]="notification?.notifications?.email?.content?.subject" />
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="notification?.notifications?.email?.content?.body" />
            </tidy-row>
          </tidy-card>
        }
        @if (detailsType === 'app') {
          <tidy-row [align]="'center'">
            <tidy-text
              [body]="'TIDY successfully sent this in app notification to'" /><span>&nbsp;</span>
              <tidy-text
                [body]="notification?.homekeeper?.first_name + ':'" />
            </tidy-row>
            <tidy-card>
              <tidy-row>
                <tidy-text
                  [header]="notification?.notifications?.app?.content?.title" />
              </tidy-row>
              <tidy-row>
                <tidy-text
                  [body]="notification?.notifications?.app?.content?.message" />
              </tidy-row>
            </tidy-card>
          }

        </tidy-wrapper>
      </ng-template>

      @if (!isRightSideContent) {
        <app-scroll-wrapper [templateContent]="content" />
      }

      @if (isRightSideContent) {
        <ion-content class="ion-content-right-column">
          <ng-container *ngTemplateOutlet="content" />
        </ion-content>
      }
